/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define(['underscore',
	'./ConversionService'
], function(_, ConversionService) {
	const conversionServiceInstance = new ConversionService();
	const ConverterInterface = conversionServiceInstance.getInterface();

	class StoryToDashboardConverter extends ConverterInterface {
		constructor(definition) {
			super(Object.assign({
				src: 'STORY',
				target: 'DASHBOARD'
			}, definition));
		}

		convert(src, target, spec) {
			return Promise.resolve().then(() => {
				const specJson = JSON.parse(spec);
				if (!this.validate(specJson)) {
					throw new Error('Invalid incoming spec');
				}
				return JSON.stringify(this._doConversion(specJson));
			});
		}
		_doConversion(spec){
			delete spec.episodes;
			return spec;
		}

		validate(spec) {
			return !!spec;
		}
	}
	return StoryToDashboardConverter;
});
